import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "ripple-container",
  ref: "containerRef"
}
const _hoisted_2 = { class: "canvas-wrapper" }
const _hoisted_3 = {
  ref: "canvasRef",
  class: "ripple-canvas"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "ripple-button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
      ref: "buttonRef"
    }, _toDisplayString(_ctx.buttonText), 513),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("canvas", _hoisted_3, null, 512)
    ], 512), [
      [_vShow, _ctx.isRippling]
    ])
  ], 512))
}